import React, { useEffect, useState } from 'react';
import { store } from '../../../app/store';
import { postAPI, postAPIForm, getURL } from '../../../app/api';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import './tooltip.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';
import Excel from '../../../components/Excel/Excel';
import { DownloadOutlined } from '@ant-design/icons';

export default function List({PopupID="", setIsEdit, setEditId}) {
    const store_data = JSON.parse(store());
    const [Gateway, setGateway] = useState([]);
    
    // Permission states
    const [canView, setCanView] = useState(false);
    const [canCreate, setCanCreate] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [canDelete, setCanDelete] = useState(false);
    const [canToggleStatus, setCanToggleStatus] = useState(false);
    const [canExport, setCanExport] = useState(false);

    const fetchGatewayCreds = async () => {
        const filter = { org_id: store_data?.org_id }
        const response = await postAPI("/gateway/list", {...filter, user: store_data});
        if (response?.status == 1) {
            setGateway(response?.data);
        } else {
            setGateway([]);
        }
        console.log(response)
    }

    useEffect(() => {
        const checkPermissions = async () => {
            if (isAdmin()) {
                setCanView(true);
                setCanCreate(true);
                setCanEdit(true);
                setCanDelete(true);
                setCanToggleStatus(true);
                setCanExport(true);
                fetchGatewayCreds();
            } else {
                const viewAllowed = await hasPermission("SETTINGS", "Gateway", "VIEW");
                const createAllowed = await hasPermission("SETTINGS", "Gateway", "CREATE");
                const editAllowed = await hasPermission("SETTINGS", "Gateway", "EDIT");
                const deleteAllowed = await hasPermission("SETTINGS", "Gateway", "DELETE");
                const toggleAllowed = await hasPermission("SETTINGS", "Gateway", "TOGGLESTATUS");
                const exportAllowed = await hasPermission("SETTINGS", "Gateway", "EXPORT");
                
                setCanView(viewAllowed);
                setCanCreate(createAllowed);
                setCanEdit(editAllowed);
                setCanDelete(deleteAllowed);
                setCanToggleStatus(toggleAllowed);
                setCanExport(exportAllowed);
                
                if (viewAllowed) {
                    fetchGatewayCreds();
                }
            }
        };
        checkPermissions();
    }, [])

    const handleCopyClipboard = text => {
        // console.log(text)
        navigator.clipboard.writeText(text)
    }

    const handleChangeStatus = async (id, status) => {
        console.log("canToggleStatus", canToggleStatus)
        if (!canToggleStatus) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id, status: status }
        const response = await postAPI("/gateway/toggle-status", {...filter, user: store_data});
        if (response?.status == 1) {
            toast.success('Status Changed Successfully.');
            window.location.reload();
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }

    const handleRemove = async id => {
        if (!canDelete) {
            toast.error('You do not have permission to perform this action');
            return;
        }
        const filter = { org_id: store_data?.org_id, id: id }
        const response = await postAPI("/gateway/remove", {...filter, user: store_data});
        if (response?.status == 1) {
            toast.success('Gateway Removed Successfully.');
            window.location.reload();
        } else {
            toast.error('Sorry ! Something Wrong. Please try to contact administrator.');
        }
    }


    return (
        <>
            <ToastContainer />
            <table class="table card-table">
                <thead>
                    <tr>
                        <th className='elipsis-td'><small>Gateway<br />Marchand ID<br />Username</small></th>
                        <th><small>Key 1</small></th>
                        <th><small>Key 2</small></th>
                        <th><small>Key 3</small></th>
                        <th><small>Key 4</small></th>
                        <th style={{width: '100px'}}><small>Default?</small></th>
                        <th style={{width: '160px'}}><small>Actions</small></th>
                    </tr>
                </thead>
                <tbody class="table-border-bottom-0">
                    {
                        !canView ? (
                            <tr>
                                <td colSpan="9" className="text-center text-danger py-4">
                                    You do not have permission to view this page.
                                </td>
                            </tr>
                        ) : Gateway && Gateway?.length > 0 ?
                            Gateway?.map((val, index) => (
                                <tr key={index + 1}>
                                    <td className='elipsis-td'>{val?.gateway_name}<br />{val?.marchant_id}<br />{val?.marchant_username}</td>
                                    <td>
                                        <span className="custom-tooltip"> ******** &nbsp; &nbsp;
                                            <span className="badge bg-label-primary me-1" onClick={() => handleCopyClipboard(val?.key1)}><i className="fa-regular fa-copy"></i></span>
                                            <span className="tooltip-text">Copy Key 1</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span className="custom-tooltip"> ******** &nbsp; &nbsp;
                                            <span className="badge bg-label-primary me-1" onClick={() => handleCopyClipboard(val?.key2)}><i className="fa-regular fa-copy"></i></span>
                                            <span className="tooltip-text">Copy Key 2</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span className="custom-tooltip"> ******** &nbsp; &nbsp;
                                            <span className="badge bg-label-primary me-1" onClick={() => handleCopyClipboard(val?.key3)}><i className="fa-regular fa-copy"></i></span>
                                            <span className="tooltip-text">Copy Key 3</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span className="custom-tooltip"> ******** &nbsp; &nbsp;
                                            <span className="badge bg-label-primary me-1" onClick={() => handleCopyClipboard(val?.key4)}><i className="fa-regular fa-copy"></i></span>
                                            <span className="tooltip-text">Copy Key 4</span>
                                        </span>
                                    </td>
                                    <td>
                                        <span className="custom-tooltip">
                                            <span className={`badge ${val?.is_default === 1 ? 'bg-label-success' : 'bg-label-secondary'} me-1 cursor-pointer`} onClick={() => handleChangeStatus(val?.id, !val?.is_default)}>{val?.is_default === 1 ? 'Active' : 'Inactive'}</span>
                                            <span className="tooltip-text">Change Status</span>
                                        </span>
                                    </td>
                                    <td>
                                        {/* <span class="badge bg-label-primary me-1"><i class="fa-regular fa-eye"></i></span> */}
                                        <span className="custom-tooltip">
                                            <span className="badge bg-label-primary me-1" data-bs-toggle="modal" data-bs-target={`#${PopupID}`} onClick={() => {setIsEdit(true);setEditId(val?.id);}}><i className="fa fa-pen"></i></span>
                                            <span className="tooltip-text">Edit Gateway</span>
                                        </span>
                                        <span className="custom-tooltip">
                                            <span className="badge bg-label-danger me-1 cursor-pointer"
                                                onClick={() => {
                                                    if (window.confirm("Are you sure? This action will permanently remove this data!")) {
                                                        handleRemove(val?.id);
                                                    } else {
                                                        console.log("Remove cancelled.");
                                                    }
                                                }}
                                            ><i className="fa fa-trash"></i></span>
                                            <span className="tooltip-text">Delete Gateway</span>
                                        </span>
                                    </td>
                                </tr>
                            ))
                            : ""
                    }
                </tbody>
            </table>
        </>
    )
}
